export default "__VITE_ASSET__DOdlayHs__"